<template>
  <b-container class="pt-4">
    <div class="my-encode">
      <div>
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-radio-group
            size="lg"
            id="radio-group-1"
            v-model="nftType"
            :options="nftTypes"
            :aria-describedby="ariaDescribedby"
            name="radio-options"
            @change="onTypeChecked"
          ></b-form-radio-group>
        </b-form-group>
      </div>
      <div>
        <h3 class="pb-2">Kuni Saru ({{ balanceSaru }})</h3>
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group
            id="checkbox-group-saru"
            v-model="selected['saru']"
            :aria-describedby="ariaDescribedby"
            name="flavour-2"
          >
            <b-form-checkbox
              v-for="saru in saruList"
              :value="saru"
              :key="`saru-${saru}`"
              @change="onChecked"
            >
              {{ saru }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
      <div>
        <h3 class="pb-2">Kuni Item ({{ balanceItem }})</h3>
        <b-form-group
          v-for="(values, key) in kuniGroup"
          :label="toKuniItemType(key)"
          v-slot="{ ariaDescribedby }"
          :key="`checkbox-group-item-${key}`"
        >
          <b-form-checkbox-group
            :id="`checkbox-group-item-${key}`"
            v-model="selected[`${key}`]"
            :aria-describedby="ariaDescribedby"
            :name="`flavour-item-${key}`"
          >
            <b-form-checkbox
              v-for="{ tokenId, powerTotal } in values"
              :value="tokenId"
              :key="`item-${key}-${tokenId}`"
              @change="onChecked"
            >
              #{{ tokenId }} ({{ utils.bigToCommon(powerTotal, 18) }})
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
      <div class="mb-3">
        <b-input-group prepend="Raw:" class="mt-3">
          <b-form-input
            v-model="raw"
            placeholder="saru+item_item_item_item_tem-saru+item_item_item_item_item..."
          ></b-form-input>
          <b-input-group-append>
            <b-button variant="info" class="px-3" @click="onEncode"
              >Encode</b-button
            >
          </b-input-group-append>
        </b-input-group>
        <b-input-group prepend="Code:" class="mt-3">
          <b-form-input
            readonly
            v-model="code"
            placeholder="Encode"
          ></b-form-input>
          <b-input-group-append>
            <b-button variant="outline-warning" class="px-3" @click="onGo"
              >Go</b-button
            >
            <b-button variant="info" class="px-3" @click="onCopy"
              >Copy</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="py-3">
        <b-button variant="info" class="w-100" @click="onFighting">
          Fighting
        </b-button>
      </div>
    </div>
  </b-container>
</template>
<script>
import { NFT, Scholarship, CoreGame } from "@/amakunicom/sdk";
import { groupBy, size } from "lodash";
export default {
  name: "ReferralPage",
  data: () => ({
    selected: {},
    saruList: [],
    kuniGroup: {},
    balanceSaru: 0,
    balanceItem: 0,
    code: "",
    raw: "",
    nftType: "scholar",
    nftTypes: [
      { text: "Scholarship", value: "scholar" },
      { text: "My NFT", value: "my-nft" },
    ],
  }),
  async created() {
    this.signer = await this.provider.getSigner();
    this.account = await this.signer.getAddress();
    this.tokens = this.getCoreConfig();
    this.game = new CoreGame(this.tokens, this.provider, this.signer);
    this.scholar = await Scholarship.initWith(
      this.tokens.scholarship,
      this.provider
    );
    this.onTypeChecked();
  },
  methods: {
    async fetchTokenIds(token, acc) {
      const tokenIds = await this.scholar.contract.valuesOf(
        token,
        acc || this.account
      );
      return { balance: size(tokenIds), tokenIds };
    },
    async fetchKuniItemMeta(tokenIds) {
      const nft = new NFT(this.tokens.kuniItem, this.provider);
      const rs = await nft.getMetaBy(tokenIds);
      tokenIds = groupBy(rs, ({ tokenId }) =>
        tokenId % 5 == 0 ? 5 : tokenId % 5
      );
      return tokenIds;
    },
    toGroupItem(items) {
      items = groupBy(items, (t) => (t % 5 == 0 ? 5 : t % 5));
      return items;
    },
    toKuniItemType(k) {
      switch (Number(k)) {
        case 1:
          return "WEAPON";
        case 2:
          return "Headgear";
        case 3:
          return "Body";
        case 4:
          return "Eyesgear";
        case 5:
          return "Hand";
        default:
          return "";
      }
    },
    getItem(_type, inx) {
      const len = size(this.selected[`${_type}`]);
      if (inx < len) return this.selected[`${_type}`][inx];
      return 0;
    },
    onCreateLink() {
      let maxLen = 6;
      const saru = this.selected.saru.slice(0, maxLen);
      maxLen = size(saru);
      let tmp = { ...this.selected };
      let maxItem = 0;
      for (let k in tmp) {
        tmp[k] = tmp[k].slice(0, maxLen);
        if (k === "saru") continue;
        if (size(tmp[k]) > maxItem) {
          maxItem = size(tmp[k]);
        }
      }
      const items = [];
      for (let inx = 0; inx < maxItem; inx++) {
        items.push(
          [
            Number(this.getItem(1, inx)),
            Number(this.getItem(2, inx)),
            Number(this.getItem(3, inx)),
            Number(this.getItem(4, inx)),
            Number(this.getItem(5, inx)),
          ].join("_")
        );
      }
      const rs = [];
      for (let j = 0; j < saru.length; j++) {
        let str = `${Number(saru[j])}`;
        if (j < items.length) {
          str = `${str}+${items[j]}`;
        }
        rs.push(str);
      }
      //   saru.forEach((element) => {});
      this.raw = rs.join("-");
      this.onEncode();
    },
    onChecked() {
      this.onCreateLink();
    },
    onEncode() {
      this.code = btoa(`${this.raw}`);
    },
    onCopy() {
      this.$clipboard(`${window.location.origin}?ids=${this.code}`)
        .then(() => {
          this.$bvToast.toast("Copied!", {
            autoHideDelay: 3000,
            variant: "success",
            title: "Successfully!",
          });
        })
        .catch(() => {
          this.$bvToast.toast("error");
        });
    },
    onGo() {
      this.onEncode();
      this.$router.push({ name: "QuickEarn", query: { ids: this.code } });
    },
    async onTypeChecked() {
      this.selected = {};
      let rs;
      let items = [];
      switch (this.nftType) {
        case "scholar":
          rs = await this.fetchTokenIds(this.tokens.kuniSaru);
          this.saruList = rs.tokenIds;
          this.balanceSaru = rs.balance;
          rs = await this.fetchTokenIds(
            this.tokens.kuniItem,
            this.tokens.scholarship
          );
          this.balanceItem = rs.balance;
          this.kuniGroup = await this.fetchKuniItemMeta(rs.tokenIds);
          break;
        case "my-nft":
          [this.saruList, this.balanceSaru] = await this.fetchNft(
            this.tokens.kuniSaru
          );
          [items, this.balanceItem] = await this.fetchNft(this.tokens.kuniItem);
          this.kuniGroup = await this.fetchKuniItemMeta(items);
          break;
        default:
          break;
      }
    },
    async fetchNft(addr) {
      const nft = await NFT.initWith(addr, this.provider);
      const { data, total } = await nft.tokenIdsOf(this.account);
      return [data, total];
    },
    async onFighting() {
      this.onEncode();
      await (await this.game.wFighting(this.code)).wait();
    },
  },
};
</script>

<style lang="scss">
.my-encode {
  color: #fff;
  background-color: transparent;
  .card-header {
    background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
      linear-gradient(to bottom, #eb345f, #eb345f);
    justify-content: center;
  }
  .t-table {
    color: #fff;
    background-color: transparent;
    .title {
      background: linear-gradient(90deg, #472f6b 0%, rgba(71, 47, 107, 0) 100%);
      font-size: 30px;
      font-style: normal;
      font-weight: 600;
      line-height: 37px;
      padding: 6px 0 6px 58px;
      margin-bottom: 12px;
    }
    .t-header {
      color: white;
    }
    .t-tr-row {
      color: white;
    }
    .t-link {
      color: white;
    }
    .no-item {
      text-align: center;
      width: 100%;
      display: block;
      color: #8d3260;
      margin-top: 30px;
      margin-bottom: 60px;
      img {
        max-width: 80px;
      }
    }
  }

  .btn-create {
    padding: 8px 16px;
    border: none;
    font-weight: 700;
    color: #fff;
    background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
      linear-gradient(to bottom, #eb345f, #eb345f);
    border-bottom: 2px solid #eb345f;
    font-weight: 700;
    text-transform: uppercase;
    position: relative;
    clip-path: polygon(0 100%, 0 34%, 8% 0%, 100% 0, 100% 100%);
    &:focus,
    &:active {
      box-shadow: none;
    }
  }
  .btn-apply {
    border: none;
    font-weight: 700;
    color: #fff;
    background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
      linear-gradient(to bottom, #eb345f, #eb345f);
    border-bottom: 2px solid #eb345f;
    font-weight: 700;
    text-transform: uppercase;
    position: relative;
    clip-path: polygon(0 100%, 0 34%, 0% 0%, 100% 0, 100% 100%);
    &:focus,
    &:active {
      box-shadow: none;
    }
  }
}
</style>
